import React from 'react';
import ReactLink from '@client/components/reactLink/ReactLink';
import styles from './policyText.scss';

function PolicyText() {
  return (
    <div className={styles.policyText}>
      Din information kommer att behandlas enligt vår{' '}
      <ReactLink
        to={'https://www.hjart-lungfonden.se/om-oss/dataskydd/'}
        className={`${styles.policyLink}`}
      >
        dataskyddspolicy
      </ReactLink>
      . Ditt namn, information tillhörande insamlingar samt information om gåvor
      publiceras offentligt. Anmäl olagligt eller olämpligt innehåll till{' '}
      <a
        className={styles.policyLink}
        href={`mailto:${'dataskydd@hjart-lungfonden.se'}`}
      >
        {'dataskydd@hjart-lungfonden.se'}
      </a>
      . Vi tar bort olagligt eller olämpligt innehåll.
    </div>
  );
}

export default PolicyText;
